<template>
    <ToolbarDropdown :is-locked="isLocked">
        <template v-slot:toggle>
            <div
                class="w-[20px] h-[20px] rounded-full cursor-pointer relative"
                :style="`background-color: ${currentColor}`"
            ></div>
        </template>
        <div
            class="
                bg-white
                p-1
                flex
                gap-2
                items-center
                justify-center
                dropdown-container
            "
        >
            <div
                v-for="color in colors"
                :key="color"
                class="cursor-pointer color-container"
                @click="changeColor(color)"
            >
                <div
                    class="w-[20px] h-[20px] rounded-full"
                    :style="{ background: color }"
                ></div>
            </div>
        </div>
    </ToolbarDropdown>
</template>

<script setup>
import { defineEmits, defineProps, reactive } from "vue";
import useWhiteboard from "../useWhiteboard";
const { currentColor, isLocked } = useWhiteboard();

const state = reactive({
    isOpen: false,
});

const colors = [
    "#000000",
    "#ca0a0aff",
    "#091cecff",
    "#09ece0ff",
    "#09ba06ff",
    "#fa9308ff",
    "#edf445ff",
    "#6725ebff",
    "#fb7287ff",
    "#747474ff",
];

function changeColor(color) {
    currentColor.value = color;
    state.isOpen = false;
}
</script>

<style scoped>
.color-container {
    border: 1px solid #f6f6f6 !important;
    padding: 6px;
    border-radius: 8px;
}

.dropdown-container {
    display: grid;
    grid-template-columns: repeat(5, 1fr);
}
</style>
